export default __webpack_public_path__ + "assets/pdf/FT_ZNV.97b7f1cd.pdf";